/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePrescriptionOrderRequestDto,
  CreatePrescriptionRequestDto,
  CreatePrescriptionResponseDto,
  EnsurePatientInRxntResponseDto,
  ErrorResponse,
  GetPrescriptionsResponseDto,
  GetProviderPrescriptionFiltersResponseDto,
  PrescriptionDto,
  SearchedPatientsForNewPrescriptionResponseDto,
} from '../models/index';
import {
    CreatePrescriptionOrderRequestDtoFromJSON,
    CreatePrescriptionOrderRequestDtoToJSON,
    CreatePrescriptionRequestDtoFromJSON,
    CreatePrescriptionRequestDtoToJSON,
    CreatePrescriptionResponseDtoFromJSON,
    CreatePrescriptionResponseDtoToJSON,
    EnsurePatientInRxntResponseDtoFromJSON,
    EnsurePatientInRxntResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPrescriptionsResponseDtoFromJSON,
    GetPrescriptionsResponseDtoToJSON,
    GetProviderPrescriptionFiltersResponseDtoFromJSON,
    GetProviderPrescriptionFiltersResponseDtoToJSON,
    PrescriptionDtoFromJSON,
    PrescriptionDtoToJSON,
    SearchedPatientsForNewPrescriptionResponseDtoFromJSON,
    SearchedPatientsForNewPrescriptionResponseDtoToJSON,
} from '../models/index';

export interface GetPrescriptionsForProviderRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForProviderSortByEnum;
    orderBy?: string;
    fromDate?: Date;
    toDate?: Date;
    fromPrice?: string;
    toPrice?: string;
    patientId?: string;
    search?: string;
    providerIds?: string;
    includeFormulas?: boolean;
}

export interface ProviderCancelPrescriptionRequest {
    prescriptionId: string;
}

export interface ProviderCreateMedicationPrescriptionRequest {
    createPrescriptionRequestDto: CreatePrescriptionRequestDto;
}

export interface ProviderCreatePrescriptionRequest {
    createPrescriptionRequestDto: CreatePrescriptionRequestDto;
}

export interface ProviderCreatePrescriptionOrderRequest {
    prescriptionId: string;
    createPrescriptionOrderRequestDto: CreatePrescriptionOrderRequestDto;
}

export interface ProviderGetPatientsRequest {
    search?: string;
    page?: number;
    pageSize?: number;
}

export interface ProviderGetPrescriptionByIdRequest {
    prescriptionId: string;
}

/**
 * 
 */
export class PrescriptionProviderApi extends runtime.BaseAPI {

    /**
     * Get prescriptions for provider
     */
    async getPrescriptionsForProviderRaw(requestParameters: GetPrescriptionsForProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = (requestParameters['fromDate'] as any).toISOString();
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = (requestParameters['toDate'] as any).toISOString();
        }

        if (requestParameters['fromPrice'] != null) {
            queryParameters['fromPrice'] = requestParameters['fromPrice'];
        }

        if (requestParameters['toPrice'] != null) {
            queryParameters['toPrice'] = requestParameters['toPrice'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patientId'] = requestParameters['patientId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['providerIds'] != null) {
            queryParameters['providerIds'] = requestParameters['providerIds'];
        }

        if (requestParameters['includeFormulas'] != null) {
            queryParameters['includeFormulas'] = requestParameters['includeFormulas'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescriptions for provider
     */
    async getPrescriptionsForProvider(requestParameters: GetPrescriptionsForProviderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancels a prescription for a provider
     * Cancel prescription for provider
     */
    async providerCancelPrescriptionRaw(requestParameters: ProviderCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling providerCancelPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/{prescriptionId}/cancel`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a prescription for a provider
     * Cancel prescription for provider
     */
    async providerCancelPrescription(requestParameters: ProviderCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.providerCancelPrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Registers patient in medication provider system
     * Register patient in medication provider system
     */
    async providerCreateMedicationPrescriptionRaw(requestParameters: ProviderCreateMedicationPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnsurePatientInRxntResponseDto>> {
        if (requestParameters['createPrescriptionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPrescriptionRequestDto',
                'Required parameter "createPrescriptionRequestDto" was null or undefined when calling providerCreateMedicationPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/medications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrescriptionRequestDtoToJSON(requestParameters['createPrescriptionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnsurePatientInRxntResponseDtoFromJSON(jsonValue));
    }

    /**
     * Registers patient in medication provider system
     * Register patient in medication provider system
     */
    async providerCreateMedicationPrescription(requestParameters: ProviderCreateMedicationPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnsurePatientInRxntResponseDto> {
        const response = await this.providerCreateMedicationPrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a prescription for a provider
     * Create prescription for provider
     */
    async providerCreatePrescriptionRaw(requestParameters: ProviderCreatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePrescriptionResponseDto>> {
        if (requestParameters['createPrescriptionRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPrescriptionRequestDto',
                'Required parameter "createPrescriptionRequestDto" was null or undefined when calling providerCreatePrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrescriptionRequestDtoToJSON(requestParameters['createPrescriptionRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePrescriptionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a prescription for a provider
     * Create prescription for provider
     */
    async providerCreatePrescription(requestParameters: ProviderCreatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePrescriptionResponseDto> {
        const response = await this.providerCreatePrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates an order for a prescription by orchestrating calls to appropriate 3rd party provider services
     * Create order for prescription
     */
    async providerCreatePrescriptionOrderRaw(requestParameters: ProviderCreatePrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling providerCreatePrescriptionOrder().'
            );
        }

        if (requestParameters['createPrescriptionOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPrescriptionOrderRequestDto',
                'Required parameter "createPrescriptionOrderRequestDto" was null or undefined when calling providerCreatePrescriptionOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/{prescriptionId}/orders`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePrescriptionOrderRequestDtoToJSON(requestParameters['createPrescriptionOrderRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates an order for a prescription by orchestrating calls to appropriate 3rd party provider services
     * Create order for prescription
     */
    async providerCreatePrescriptionOrder(requestParameters: ProviderCreatePrescriptionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.providerCreatePrescriptionOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get patients for provider
     */
    async providerGetPatientsRaw(requestParameters: ProviderGetPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchedPatientsForNewPrescriptionResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/patients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchedPatientsForNewPrescriptionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patients for provider
     */
    async providerGetPatients(requestParameters: ProviderGetPatientsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchedPatientsForNewPrescriptionResponseDto> {
        const response = await this.providerGetPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription by ID for provider
     */
    async providerGetPrescriptionByIdRaw(requestParameters: ProviderGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling providerGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription by ID for provider
     */
    async providerGetPrescriptionById(requestParameters: ProviderGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.providerGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription filters for provider
     */
    async providerGetPrescriptionFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProviderPrescriptionFiltersResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/prescription/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProviderPrescriptionFiltersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription filters for provider
     */
    async providerGetPrescriptionFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProviderPrescriptionFiltersResponseDto> {
        const response = await this.providerGetPrescriptionFiltersRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPrescriptionsForProviderSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForProviderSortByEnum = typeof GetPrescriptionsForProviderSortByEnum[keyof typeof GetPrescriptionsForProviderSortByEnum];
